<rask-container-block>
  <ng-container header>
    <rask-header size="2" underline>{{ 'DESTINERINGSOMRADEN_EDITERA_HEADER' | translate }}</rask-header>
  </ng-container>
  <form [formGroup]="form" (ngSubmit)="save()" autocomplete="off">
    <div class="formContainer">

      @if (isDisabled()) {
        <rask-validation-message-row type="info"
          message="{{ 'DESTINERINGSOMRADEN_INGET_VALT' | translate }}">
        </rask-validation-message-row>
      }

      <rask-input
        label="{{'DESTINERINGSOMRADEN_EDIT_NAMN' | translate}}"
        class="w-100"
        formControlName="namn"
        [disabled]="isDisabled()"
        [raskRule]="validationContext.current.namn">
      </rask-input>

      @if (handelssortiment) {
        <rask-multi-selector
          label="{{'DESTINERINGSOMRADEN_HANDELSSORTIMENT' | translate}}"
          class="w-100"
          [items]="handelssortiment"
          formControlName="handelssortiment"
          [selected]="form.value.handelssortiment"
          [searchFn]=handelssortimentSearchFn
          [viewFormatter]="handelssortimentViewFormatter"
          [formatter]="handelssortimentSelectedFormatter"
          [viewSelectedFormatter]="handelssortimentViewFormatter"
          [disabled]="isDisabled()">
        </rask-multi-selector>
      }

      <rask-multi-selector
        class="col-12"
        label="{{'DESTINERINGSOMRADEN_MOTTAGNIGSPLATS' | translate}}"
        bindLabel="namn"
        formControlName="mottagningsplatser"
        typeToSearchText="Ange minst tre tecken"
        loadingText="Laddar..."
        notFoundText="Ingen träff"
        [minTermLength]="3"
        [typeaheadFn]="searchForMottagningsplatsTypeAhead"
        [selected]="form.value.mottagningsplatser"
        [disabled]="isDisabled()">
      </rask-multi-selector>

      <rask-radiobutton-group
        label="{{ 'DESTINERINGSOMRADEN_AKTIV' | translate }}"
        [buttons]="aktivRadiobuttons"
        class="w-50"
        formControlName="aktiv"
        [disabled]="isDisabled()">
      </rask-radiobutton-group>

      <div class="colorpicker-container">
        <fieldset class="form-group inline mb-3">
          <label>{{'DESTINERINGSOMRADEN_FARG' | translate}}</label>
          <div class="picker-input-group">
            <div (click)="openColorPicker()" class="colorpicker"
              [ngStyle]="{'background-color' : color }">
            </div>
          </div>
        </fieldset>
      </div>
    </div>

    <ng-container footer>
      <rask-submit-button color="primary" class="large-button float-start"
        [disabled]="hasErrors() || !isDirty()">
        {{ 'DEFAULT_BUTTON_LABEL_SPARA' | translate }}
      </rask-submit-button>
      <rask-button color="secondary" (click)="cancel()" class="large-button float-end"
        [disabled]="!isDirty()">
        {{ 'DEFAULT_BUTTON_LABEL_AVBRYT' | translate }}
      </rask-button>
      <rask-button color="secondary" (click)="delete()" negative
        class="large-button float-end" [disabled]="isDisabled() || isNewUnsaved()">
        {{ 'DEFAULT_BUTTON_LABEL_DELETE' | translate }}
      </rask-button>
    </ng-container>

  </form>
</rask-container-block>